/* 
	投注页面 导航菜单  所有游戏种类
*/
import React from 'react'
import { withBetterRouter } from '$LIB/js/withBetterRouter';
import { ReactSVG } from '@/ReactSVG';
import { DataConsumer } from '@/DataProvider/';
import Bottomsheet from '@/Games/Footer/bottomsheet';
import Bottomtime from '@/Games/Footer/bottomtime';
import moment from 'moment';
import {VendorMarkets} from "../../../lib/vendor/data/VendorConsts";
import HeaderMenu from "./menu";
const theDayAfterTenDays = moment().add(10, 'days').format('YYYY-MM-DD');
const theDaytoday = moment().format('YYYY-MM-DD');

class Bettingnav extends React.Component {
	constructor() {
		super();
		this.state = {
			chosegame: '-1',
			isopen: false,
			isExpandAll: true, //默認全展開
			SportId: 1,
			MarketId: VendorMarkets.TODAY, //默認選 今日(包含滾球)
			SortWay: 1 /*排序 1联赛 2时间 0不指定排序  */,
			Selectdate: theDayAfterTenDays,
			currentMenu: null,
			navBarFreeze: false,
		};

		this.navRef = React.createRef();
		this.sportsMore = React.createRef();
		this.marketsMore  = React.createRef();

		this.clickMenu = this.clickMenu.bind(this);
		this.clickSport = this.clickSport.bind(this);
		this.clickMarket = this.clickMarket.bind(this);
	}

	componentDidMount() {
		this.props.NavRef && this.props.NavRef(this);

		const {query} = this.props.router; //從鏈接獲取要加載的參數

		if(!(JSON.stringify(query) === "{}" || !query)) {
			//有傳入參數
			const {SportId,MarketId,SortWay,Selectdate} = this.state;
			let cloneQuery = Object.assign({SportId,MarketId,SortWay},query);

			//處理一下數據格式，要用int型態
			cloneQuery.SportId = parseInt(cloneQuery.SportId);
			cloneQuery.MarketId = parseInt(cloneQuery.MarketId);
			cloneQuery.SortWay = parseInt(cloneQuery.SortWay);

			//特別處理日期，實際上只會選一天
			cloneQuery.Selectdate = query.EndDate ?? Selectdate;

			//從路由更新 下拉菜單 選中項目
			this.setState({ SportId:cloneQuery.SportId, MarketId: cloneQuery.MarketId, SortWay: cloneQuery.SortWay, Selectdate: cloneQuery.Selectdate })

			//更新banner
			this.props.MenuChange(cloneQuery.SportId);
		}

		//處理捲動時，navbar固定在上方
		const handleScroll = (topOffset = 0) => {
			const bettingList = document.getElementById("Betting-list");

			if (this.navRef.current && bettingList) {
				const lgbcr = this.navRef.current.getBoundingClientRect(); //玩法組橫條
				var lgbcr_height = lgbcr.height||(lgbcr.bottom - lgbcr.top); //相容ie
				const lcbcr = bettingList.getBoundingClientRect(); //玩法列表

				//凍結的條件： 玩法列表的top 小於等於  天花板 +玩法組的height)
				//注意上面有header(topOffset) 版本迭代 已删除
				const freeze = lcbcr.top <= lgbcr_height; //+ topOffset;
				//console.log('===',freeze,lcbcr.top,'<=',lgbcr_height + topOffset,lgbcr_height);
				if (this.state.navBarFreeze !== freeze) { //減少觸發render次數
					this.setState({navBarFreeze: freeze});
				}
			} else {
				//console.log('===navRefs not FOUND');
			}
		}

		const headerBar = document.getElementById("header-bar");
		let topOffset = 0;
		if(headerBar) {
			topOffset = headerBar.clientHeight;
		}

		this.handleScrollForNavbar = () => handleScroll(topOffset);

		window.addEventListener("scroll", this.handleScrollForNavbar);
	}

	componentWillUnmount() {
		if (this.handleScrollForNavbar) {
			window.removeEventListener("scroll", this.handleScrollForNavbar)
		}
	}

	clickMenu(menuName) {
		let newMenuName = menuName;
		if (this.state.currentMenu === newMenuName) {
			newMenuName = null; //如果已經選中，再點一次就是取消
		}
		this.setState({currentMenu:newMenuName});
	}
	clickSport(sportData) {
		const sportId = sportData.SportId;
		this.setState(
			{
				SportId: sportId
			},
			() => {
				this.ChangeGame();
				this.props.MenuChange(sportId); //banner刷新
			}
		);
	}
	clickMarket(marketData) {
		const marketId = marketData.MarketId;
		this.setState(
			{
				MarketId: marketId
			},
			() => {
				this.ChangeGame();
			}
		);
	}

	/* 选择游戏 */
	ChangeGame = (date) => {
		const { SportId, MarketId, SortWay } = this.state;
		let StartDate = date ? moment(new Date(date)).format('YYYY-MM-DD') : theDaytoday; /* 今天 */
		let EndDate = date ? moment(new Date(date)).format('YYYY-MM-DD') : theDayAfterTenDays; /* 10天後 */
		const type = {
			SportId: SportId /* 体育类型 */,
			MarketId: MarketId /* 市场类型 */,
			SortWay: SortWay /* 排序 */,
			StartDate: StartDate /* 开始日期 */,
			EndDate: EndDate /* 结束日期 */
		};
		this.props.GetEvents(type);
		this.setState({
			Selectdate: date,
			isExpandAll: true, //選擇變化之後  要重置(全展開)
		},() => {
			this.props.onToggleButtonClicked(true)
		});
	};

	changeToggleButtonStatus = (isExpandAll) => {
		this.setState({isExpandAll} );
	}

	render() {
		const { SportId, MarketId, Selectdate  } = this.state;
		const { SportDatas, Loading } = this.props;
		let selectedSport, selectedMarket;
		if (SportDatas) {
			const targetSports = SportDatas.filter(s => parseInt(s.SportId) === parseInt(SportId));
			if (targetSports && targetSports.length > 0) {
				selectedSport = targetSports[0];
			} else {
				selectedSport = SportDatas[0]; //找不到就默認用第一個
			}
			if (selectedSport) {
				const targetMarkets = selectedSport.Markets.filter(m => parseInt(m.MarketId) === parseInt(MarketId));
				if (targetMarkets && targetMarkets.length > 0) {
					selectedMarket = targetMarkets[0];
				}
			}
		}
		//console.log('%c游戏分类和游戏计数', 'font-size:18px;color:red;', SportDatas); /* 赛事种类和计数 */
		//console.log(selectedSport)
		return (
			<div className={this.state.navBarFreeze ? "Betting-nav freeze" : "Betting-nav"} ref={this.navRef}>
				<div className="Tabsbox">
					{/* 體育菜單 */}
					<HeaderMenu
						menuName="sport"
						currentMenuName={this.state.currentMenu}
						items={SportDatas}
						selectedItem={selectedSport}
						formatItem={(item) => item.SportName + ' ' + item.Count}
						getItemKey={(item) => item.SportId}
						onClickMenu={this.clickMenu}
						onClickItem={this.clickSport}
						onClickMoreButton={() => { this.sportsMore.current.show() }}
					/>
					{/* 市場菜單 */}
					<HeaderMenu
						menuName="market"
						currentMenuName={this.state.currentMenu}
						items={selectedSport?selectedSport.Markets:[]}
						selectedItem={selectedMarket}
						formatItem={(item) => item.MarketName + ' ' + item.Count}
						getItemKey={(item) => item.MarketId}
						onClickMenu={this.clickMenu}
						onClickItem={this.clickMarket}
						onClickMoreButton={() => { this.marketsMore.current.show() }}
					/>
				</div>
				<div className="Switchcontainer">
					<label>
						<input className="Game-switch" type="checkbox" hidden checked={this.state.SortWay === 2} readOnly="readOnly" />
						<div className="Game-switch-text"
								 onClick={() => {
									 let targetWay = 2;
									 if (this.state.SortWay === 2) {
										 targetWay = 1;
									 }
									 this.setState(
										 {
											 SortWay: targetWay
										 },
										 () => {
											 this.ChangeGame();
										 }
									 );
								 }}
						>
							<span>
								联赛
							</span>
							<span>
								时间
							</span>
						</div>
					</label>
				</div>
						<div
							className="Nav-colse-icon"
							onClick={() => {
								this.setState({
									isExpandAll: !this.state.isExpandAll
								},() => {
									this.props.onToggleButtonClicked(this.state.isExpandAll)
								});
							}}
						>
							<ReactSVG
								className="Betting-show-svg"
								src={`/svg/betting/${this.state.isExpandAll ? 's_o' : 's_c'}.svg`}
							/>
						</div>
				{/* 日期动作面板 */}
				{selectedMarket && parseInt(selectedMarket.MarketId) === VendorMarkets.EARLY &&  //早盤才可以選日期
				!Loading && (
					<Bottomtime ChangeGame={(e) => this.ChangeGame(e)} Selectdate={Selectdate} SportId={SportId} />
				)}
				{/* 點擊菜單的「更多」出現的下浮窗 */}
				{/* 體育 */}
				<Bottomsheet
					ref={this.sportsMore}
					headerName="全部体育"
					items={SportDatas}
					selectedItem={selectedSport}
					formatItem={(item) => item.SportName + ' ' + item.Count}
					getItemKey={(item) => item.SportId}
					onClickItem={this.clickSport}
				/>
				{/* 市場 */}
				<Bottomsheet
					ref={this.marketsMore}
					headerName="全部选项"
					items={selectedSport ? selectedSport.Markets : []}
					selectedItem={selectedMarket}
					formatItem={(item) => item.MarketName + ' ' + item.Count}
					getItemKey={(item) => item.MarketId}
					onClickItem={this.clickMarket}
				/>
			</div>
		);
	}
}
export default withBetterRouter(Bettingnav);
